import "../Admin.css";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import * as API from "../../Utils/Services/api";
import { toast } from "react-toastify";

const CondoAddAdmins = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loginError, setLoginError] = useState("");
  const [formData, setFormData] = useState({ email: "", password: "" });

  const onPreview = () => setIsVisible((prev) => !prev);
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      setLoginError("");

      const response = await API.AddAdminAPI(data);

      if (response.status === 200) {
        setIsLoading(false);
        toast.success("Admin added Successfully");
      } else {
        setErrorMsg("Failed to add admin");
        toast.error("Failed to add admin");
      }
    } catch (err) {
      setErrorMsg(err.response?.data?.message || "Something went wrong");
      toast.error("Error occurred while adding admin");
    } finally {
      setIsLoading(false);
    }
  };
  // const onSubmit = async (data) => {
  //   setIsLoading(true);
  //   setErrorMsg("");

  //   try {
  //     // const response = await AddAdminAPI(data);
  //     // if (response.status) {
  //     toast.success("Admin added successfully");
  //   } catch (err) {
  //     setErrorMsg("Something went wrong");
  //   } finally {
  //     setIsLoading(false);
  //   }
  //   //     navigate("/admin/dashboard"); // 🔁 Change to your desired path
  //   //   } else {
  //   //     setErrorMsg("Failed to add admin");
  //   //   }
  //   // } catch (err) {
  //   //   setErrorMsg("Something went wrong");
  //   // } finally {
  //   //   setIsLoading(false);
  //   // }
  // };
  const inputHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div className="condo-admin-dashboard-pg">
      <div className="admin-dashboard-main-pg">
        <div className="container-fluid" style={{ padding: 0 }}>
          <div className="">
            <div className="container">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="login-form">
                  <h4>Add New Admin</h4>
                  {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}

                  <div className="login-form-details mt-4">
                    <div className="email-credentials">
                      <p className="pb-2">USERNAME</p>

                      <input
                        type="text"
                        name="username"
                        onChange={inputHandler}
                        placeholder="Enter admins username"
                        {...register("username", {
                          required: "Username is required",
                          pattern: {
                            value: /^\S+$/,
                            message: "Username must not contain spaces",
                          },
                          minLength: {
                            value: 3,
                            message: "Username must be at least 3 characters",
                          },
                        })}
                      />
                      {errors.username && (
                        <p style={{ color: "red" }}>
                          {errors.username.message}
                        </p>
                      )}
                    </div>{" "}
                    <div className="email-credentials">
                      <p className="pb-2">EMAIL</p>
                      <input
                        type="text"
                        name="email"
                        onChange={inputHandler}
                        placeholder="Enter admin email"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Enter a valid email address",
                          },
                        })}
                      />
                      {errors.email && (
                        <p style={{ color: "red" }}>{errors.email.message}</p>
                      )}
                    </div>
                    <div className="password-credentials">
                      <p className="pb-2">PASSWORD</p>
                      <div className="input-container">
                        <input
                          type={isVisible ? "text" : "password"}
                          name="password"
                          onChange={inputHandler}
                          placeholder="Enter admin password"
                          className="input-with-icon"
                          {...register("password", {
                            required: "Password is required",
                            minLength: {
                              value: 8,
                              message:
                                "Password must be at least 8 characters long",
                            },
                          })}
                        />
                        <i
                          className={`fa-solid ${
                            isVisible ? "fa-eye" : "fa-eye-slash"
                          }`}
                          onClick={onPreview}
                        ></i>
                      </div>
                      {errors.password && (
                        <p
                          style={{
                            color: "red",
                            fontSize: "small",
                            letterSpacing: "2.4px",
                          }}
                        >
                          {errors.password.message}
                        </p>
                      )}
                    </div>
                    <div className="sign-up-btn">
                      <button type="submit" disabled={isLoading}>
                        {isLoading ? "Adding..." : "ADD ADMIN"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* No ForgetPassModal needed here */}
        </div>
      </div>
    </div>
  );
};

export default CondoAddAdmins;
